import StarSVG from '@/svg/icons/star.svg';

import styles from './Ratings.module.css';

function Stars({ value }) {
  return (
    <div className="mb-2 flex justify-center">
      {new Array(value).fill(0).map((_, index) => (
        <div className="px-0.5" key={index}>
          <StarSVG className="w-5 text-yellow-500" />
        </div>
      ))}
    </div>
  );
}

function Rating({ platform, url, value }) {
  return (
    <div className="text-center">
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-sm font-medium hover:text-cornflower"
        >
          <Stars value={value} />
          {platform}
        </a>
      ) : (
        <>
          <Stars value={value} />
          <span className="mb-2 block text-sm font-medium">{platform}</span>
        </>
      )}
    </div>
  );
}

export default function Ratings({ ratings }) {
  const Component = (rating, index) => <Rating key={index} {...rating} />;

  return <div className={styles.grid}>{ratings.map(Component)}</div>;
}
